export default "__VITE_ASSET__BdEWcPVr__";